/** The opt-out from sharing item names (SM-22), under an item form's fields. */
export function ShareNameCheckbox({ checked, onChange }: { checked: boolean; onChange: (on: boolean) => void }) {
  return (
    <label className="flex items-start gap-2 text-xs text-ink/70 mb-4">
      <input type="checkbox" className="mt-0.5" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      Share what you call new items with Snapshot Money to improve suggestions for everyone
    </label>
  )
}
